/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ProjectSettingsPage_project$ref = any;
export type BUDGET_TYPE = "FIXED_PRICE" | "FIXED_PRICE_V2" | "NON_BILLABLE" | "RETAINER" | "TIME_AND_MATERIALS" | "%future added value";
export type PERIODICITY = "DAILY" | "MONTHLY" | "WEEKLY" | "%future added value";
export type PERIOD_BUDGET_TYPE = "FIXED_HOURS" | "FIXED_PRICE" | "TIME_AND_MATERIALS" | "%future added value";
export type UpdateProjectInput = {|
  id?: ?string,
  name?: ?string,
  description?: ?string,
  status?: ?string,
  active?: ?boolean,
  projectColor?: ?string,
  clientId?: ?string,
  projectOwner?: ?string,
  projectManagers?: ?$ReadOnlyArray<?string>,
  statusColumns?: ?$ReadOnlyArray<?StatusColumnInput>,
  estimationUnit?: ?string,
  sprintTimeBox?: ?boolean,
  sprintLengthInDays?: ?number,
  projectStartYear?: ?number,
  projectStartMonth?: ?number,
  projectStartDay?: ?number,
  projectEndYear?: ?number,
  projectEndMonth?: ?number,
  projectEndDay?: ?number,
  taskLevels?: ?number,
  useTaskHierarchy?: ?boolean,
  rateCardId?: ?string,
  labels?: ?$ReadOnlyArray<?string>,
  minutesPerEstimationPoint?: ?number,
  budget?: ?number,
  budgetType?: ?BUDGET_TYPE,
  defaultPeriodPriceAmount?: ?number,
  defaultPeriodHoursAmount?: ?number,
  defaultPeriodBudgetType?: ?PERIOD_BUDGET_TYPE,
  defaultPeriodLength?: ?number,
  defaultPeriodPeriodicity?: ?PERIODICITY,
  defaultPeriodSettingIgnoreForBilling?: ?boolean,
  defaultPeriodSettingSubtractValue?: ?boolean,
  defaultPeriodSettingRollValue?: ?boolean,
  defaultPeriodSettingAddExpenses?: ?boolean,
  economicProjectId?: ?string,
  harvestProjectId?: ?string,
  newHarvestProjectId?: ?string,
  jiraProjectId?: ?string,
  excludedHarvestTasks?: ?$ReadOnlyArray<?string>,
  newExcludedHarvestTasks?: ?$ReadOnlyArray<?number>,
  timelogProjectId?: ?string,
  newTimelogProjectId?: ?string,
  initTaskImport?: ?boolean,
  slackChannelId?: ?string,
  approveNoPhaseTasks?: ?boolean,
  billable?: ?boolean,
  projectGroupId?: ?string,
  previousProjectGroupId?: ?string,
  salesforceOpportunity?: ?string,
  unit4Project?: ?string,
  githubRepositories?: ?$ReadOnlyArray<?string>,
  githubRepositoryIds?: ?$ReadOnlyArray<?number>,
  remainingAutoCalculated?: ?boolean,
  useManualAllocations?: ?boolean,
  taskCostCalculationType?: ?string,
  unassignedTaskHourlyCost?: ?number,
  useTaskOwner?: ?boolean,
  useTaskFollowers?: ?boolean,
  currencyExchangeRate?: ?number,
  fixedPriceRateCardSetting?: ?number,
  usePublicCreateTaskPage?: ?boolean,
  usePublicCreateTaskPassword?: ?boolean,
  publicCreateTaskPassword?: ?string,
  publicCreateTaskPageStatusColumnId?: ?string,
  unsynchedJiraProject?: ?boolean,
  useBaseline?: ?boolean,
  baselineWinChance?: ?number,
  baselineTarget?: ?number,
  baselineMinutesPerDay?: ?number,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type StatusColumnInput = {|
  id?: ?string,
  name?: ?string,
  order?: ?number,
  category?: ?string,
  projectId?: ?string,
  projectGroupStatusColumnId?: ?number,
  autoShowOnTimePage?: ?boolean,
  encourageTimeRegistration?: ?boolean,
|};
export type updateProjectMutationModernMutationVariables = {|
  input: UpdateProjectInput
|};
export type updateProjectMutationModernMutationResponse = {|
  +updateProject: ?{|
    +errors: ?$ReadOnlyArray<?string>,
    +project: ?{|
      +company: ?{|
        +roles: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +name: ?string,
            |}
          |}>
        |},
        +modules: ?$ReadOnlyArray<?{|
          +moduleType: ?string
        |}>,
        +expenseCategories: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +name: ?string,
            |}
          |}>
        |},
      |},
      +xeroInvoices: ?$ReadOnlyArray<?{|
        +id: string,
        +amountTotal: ?number,
        +amountNoTax: ?number,
        +amountPaid: ?number,
      |}>,
      +invoices: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +name: ?string,
            +invoiceType: ?string,
            +status: ?string,
            +entries: ?{|
              +edges: ?$ReadOnlyArray<?{|
                +node: ?{|
                  +id: string,
                  +name: ?string,
                  +quantity: ?number,
                  +unitPrice: ?number,
                  +discount: ?number,
                  +tax: ?number,
                  +description: ?string,
                |}
              |}>
            |},
            +payments: ?{|
              +edges: ?$ReadOnlyArray<?{|
                +node: ?{|
                  +id: string,
                  +amount: ?number,
                |}
              |}>
            |},
          |}
        |}>
      |},
      +registeredMinutesPerDay: ?$ReadOnlyArray<?{|
        +date: ?string,
        +value: ?number,
      |}>,
      +remainingMinutesPerDay: ?$ReadOnlyArray<?{|
        +date: ?string,
        +value: ?number,
      |}>,
      +plannedMinutesPerDay: ?$ReadOnlyArray<?{|
        +date: ?string,
        +value: ?number,
      |}>,
      +costPlannedPerDay: ?$ReadOnlyArray<?{|
        +date: ?string,
        +value: ?number,
      |}>,
      +pricePlannedPerDay: ?$ReadOnlyArray<?{|
        +date: ?string,
        +value: ?number,
      |}>,
      +costRemainingPerDay: ?$ReadOnlyArray<?{|
        +date: ?string,
        +value: ?number,
      |}>,
      +priceRemainingPerDay: ?$ReadOnlyArray<?{|
        +date: ?string,
        +value: ?number,
      |}>,
      +costActualPerDay: ?$ReadOnlyArray<?{|
        +date: ?string,
        +value: ?number,
      |}>,
      +priceActualPerDay: ?$ReadOnlyArray<?{|
        +date: ?string,
        +value: ?number,
      |}>,
      +costPlannedWorkPerDay: ?$ReadOnlyArray<?{|
        +date: ?string,
        +value: ?number,
      |}>,
      +pricePlannedWorkPerDay: ?$ReadOnlyArray<?{|
        +date: ?string,
        +value: ?number,
      |}>,
      +costRemainingWorkPerDay: ?$ReadOnlyArray<?{|
        +date: ?string,
        +value: ?number,
      |}>,
      +priceRemainingWorkPerDay: ?$ReadOnlyArray<?{|
        +date: ?string,
        +value: ?number,
      |}>,
      +costActualWorkPerDay: ?$ReadOnlyArray<?{|
        +date: ?string,
        +value: ?number,
      |}>,
      +priceActualWorkPerDay: ?$ReadOnlyArray<?{|
        +date: ?string,
        +value: ?number,
      |}>,
      +pricePlannedExpensesPerDay: ?$ReadOnlyArray<?{|
        +date: ?string,
        +value: ?number,
      |}>,
      +costPlannedExpensesPerDay: ?$ReadOnlyArray<?{|
        +date: ?string,
        +value: ?number,
      |}>,
      +priceActualExpensesPerDay: ?$ReadOnlyArray<?{|
        +date: ?string,
        +value: ?number,
      |}>,
      +costActualExpensesPerDay: ?$ReadOnlyArray<?{|
        +date: ?string,
        +value: ?number,
      |}>,
      +priceRemainingExpensesPerDay: ?$ReadOnlyArray<?{|
        +date: ?string,
        +value: ?number,
      |}>,
      +costRemainingExpensesPerDay: ?$ReadOnlyArray<?{|
        +date: ?string,
        +value: ?number,
      |}>,
      +invoicedPerDay: ?$ReadOnlyArray<?{|
        +date: ?string,
        +value: ?number,
      |}>,
      +totalPaymentsPerDay: ?$ReadOnlyArray<?{|
        +date: ?string,
        +value: ?number,
      |}>,
      +baselinePricePerDay: ?$ReadOnlyArray<?{|
        +date: ?string,
        +value: ?number,
      |}>,
      +baselineCostPerDay: ?$ReadOnlyArray<?{|
        +date: ?string,
        +value: ?number,
      |}>,
      +baselineProfitPerDay: ?$ReadOnlyArray<?{|
        +date: ?string,
        +value: ?number,
      |}>,
      +baselineMinutesPerDay: ?$ReadOnlyArray<?{|
        +date: ?string,
        +value: ?number,
      |}>,
      +baselineUnplannedPricePerDay: ?$ReadOnlyArray<?{|
        +date: ?string,
        +value: ?number,
      |}>,
      +baselineUnplannedMinutesPerDay: ?$ReadOnlyArray<?{|
        +date: ?string,
        +value: ?number,
      |}>,
      +breakdownForecastMinutesPerDay: ?$ReadOnlyArray<?{|
        +milestoneId: ?string,
        +roleBreakdown: ?$ReadOnlyArray<?{|
          +roleId: ?string,
          +breakdown: ?$ReadOnlyArray<?{|
            +date: ?string,
            +value: ?number,
          |}>,
        |}>,
      |}>,
      +breakdownRemainingMinutesPerDay: ?$ReadOnlyArray<?{|
        +milestoneId: ?string,
        +roleBreakdown: ?$ReadOnlyArray<?{|
          +roleId: ?string,
          +breakdown: ?$ReadOnlyArray<?{|
            +date: ?string,
            +value: ?number,
          |}>,
        |}>,
      |}>,
      +breakdownActualMinutesPerDay: ?$ReadOnlyArray<?{|
        +milestoneId: ?string,
        +roleBreakdown: ?$ReadOnlyArray<?{|
          +roleId: ?string,
          +breakdown: ?$ReadOnlyArray<?{|
            +date: ?string,
            +value: ?number,
          |}>,
        |}>,
      |}>,
      +breakdownCostForecastPerDay: ?$ReadOnlyArray<?{|
        +milestoneId: ?string,
        +roleBreakdown: ?$ReadOnlyArray<?{|
          +roleId: ?string,
          +breakdown: ?$ReadOnlyArray<?{|
            +date: ?string,
            +value: ?number,
          |}>,
        |}>,
      |}>,
      +breakdownCostRemainingPerDay: ?$ReadOnlyArray<?{|
        +milestoneId: ?string,
        +roleBreakdown: ?$ReadOnlyArray<?{|
          +roleId: ?string,
          +breakdown: ?$ReadOnlyArray<?{|
            +date: ?string,
            +value: ?number,
          |}>,
        |}>,
      |}>,
      +breakdownCostActualPerDay: ?$ReadOnlyArray<?{|
        +milestoneId: ?string,
        +roleBreakdown: ?$ReadOnlyArray<?{|
          +roleId: ?string,
          +breakdown: ?$ReadOnlyArray<?{|
            +date: ?string,
            +value: ?number,
          |}>,
        |}>,
      |}>,
      +breakdownPricePlannedPerDay: ?$ReadOnlyArray<?{|
        +milestoneId: ?string,
        +roleBreakdown: ?$ReadOnlyArray<?{|
          +roleId: ?string,
          +breakdown: ?$ReadOnlyArray<?{|
            +date: ?string,
            +value: ?number,
          |}>,
        |}>,
      |}>,
      +breakdownPriceRemainingPerDay: ?$ReadOnlyArray<?{|
        +milestoneId: ?string,
        +roleBreakdown: ?$ReadOnlyArray<?{|
          +roleId: ?string,
          +breakdown: ?$ReadOnlyArray<?{|
            +date: ?string,
            +value: ?number,
          |}>,
        |}>,
      |}>,
      +breakdownPriceActualPerDay: ?$ReadOnlyArray<?{|
        +milestoneId: ?string,
        +roleBreakdown: ?$ReadOnlyArray<?{|
          +roleId: ?string,
          +breakdown: ?$ReadOnlyArray<?{|
            +date: ?string,
            +value: ?number,
          |}>,
        |}>,
      |}>,
      +breakdownCostForecastWorkPerDay: ?$ReadOnlyArray<?{|
        +milestoneId: ?string,
        +roleBreakdown: ?$ReadOnlyArray<?{|
          +roleId: ?string,
          +breakdown: ?$ReadOnlyArray<?{|
            +date: ?string,
            +value: ?number,
          |}>,
        |}>,
      |}>,
      +breakdownCostRemainingWorkPerDay: ?$ReadOnlyArray<?{|
        +milestoneId: ?string,
        +roleBreakdown: ?$ReadOnlyArray<?{|
          +roleId: ?string,
          +breakdown: ?$ReadOnlyArray<?{|
            +date: ?string,
            +value: ?number,
          |}>,
        |}>,
      |}>,
      +breakdownCostActualWorkPerDay: ?$ReadOnlyArray<?{|
        +milestoneId: ?string,
        +roleBreakdown: ?$ReadOnlyArray<?{|
          +roleId: ?string,
          +breakdown: ?$ReadOnlyArray<?{|
            +date: ?string,
            +value: ?number,
          |}>,
        |}>,
      |}>,
      +breakdownPricePlannedWorkPerDay: ?$ReadOnlyArray<?{|
        +milestoneId: ?string,
        +roleBreakdown: ?$ReadOnlyArray<?{|
          +roleId: ?string,
          +breakdown: ?$ReadOnlyArray<?{|
            +date: ?string,
            +value: ?number,
          |}>,
        |}>,
      |}>,
      +breakdownPriceRemainingWorkPerDay: ?$ReadOnlyArray<?{|
        +milestoneId: ?string,
        +roleBreakdown: ?$ReadOnlyArray<?{|
          +roleId: ?string,
          +breakdown: ?$ReadOnlyArray<?{|
            +date: ?string,
            +value: ?number,
          |}>,
        |}>,
      |}>,
      +breakdownPriceActualWorkPerDay: ?$ReadOnlyArray<?{|
        +milestoneId: ?string,
        +roleBreakdown: ?$ReadOnlyArray<?{|
          +roleId: ?string,
          +breakdown: ?$ReadOnlyArray<?{|
            +date: ?string,
            +value: ?number,
          |}>,
        |}>,
      |}>,
      +breakdownBaselinePricePerDay: ?$ReadOnlyArray<?{|
        +milestoneId: ?string,
        +roleBreakdown: ?$ReadOnlyArray<?{|
          +roleId: ?string,
          +breakdown: ?$ReadOnlyArray<?{|
            +date: ?string,
            +value: ?number,
          |}>,
        |}>,
      |}>,
      +breakdownBaselineCostPerDay: ?$ReadOnlyArray<?{|
        +milestoneId: ?string,
        +roleBreakdown: ?$ReadOnlyArray<?{|
          +roleId: ?string,
          +breakdown: ?$ReadOnlyArray<?{|
            +date: ?string,
            +value: ?number,
          |}>,
        |}>,
      |}>,
      +breakdownBaselineProfitPerDay: ?$ReadOnlyArray<?{|
        +milestoneId: ?string,
        +roleBreakdown: ?$ReadOnlyArray<?{|
          +roleId: ?string,
          +breakdown: ?$ReadOnlyArray<?{|
            +date: ?string,
            +value: ?number,
          |}>,
        |}>,
      |}>,
      +breakdownBaselineMinutesPerDay: ?$ReadOnlyArray<?{|
        +milestoneId: ?string,
        +roleBreakdown: ?$ReadOnlyArray<?{|
          +roleId: ?string,
          +breakdown: ?$ReadOnlyArray<?{|
            +date: ?string,
            +value: ?number,
          |}>,
        |}>,
      |}>,
      +breakdownBaselineExpensesPricePerDay: ?$ReadOnlyArray<?{|
        +milestoneId: string,
        +expenseCategoryBreakdown: ?$ReadOnlyArray<?{|
          +expenseCategoryId: string,
          +breakdown: ?$ReadOnlyArray<?{|
            +date: ?string,
            +value: ?number,
          |}>,
        |}>,
      |}>,
      +breakdownBaselineExpensesCostPerDay: ?$ReadOnlyArray<?{|
        +milestoneId: string,
        +expenseCategoryBreakdown: ?$ReadOnlyArray<?{|
          +expenseCategoryId: string,
          +breakdown: ?$ReadOnlyArray<?{|
            +date: ?string,
            +value: ?number,
          |}>,
        |}>,
      |}>,
      +breakdownExpensesPlannedPricePerDay: ?$ReadOnlyArray<?{|
        +milestoneId: string,
        +expenseCategoryBreakdown: ?$ReadOnlyArray<?{|
          +expenseCategoryId: string,
          +breakdown: ?$ReadOnlyArray<?{|
            +date: ?string,
            +value: ?number,
          |}>,
        |}>,
      |}>,
      +breakdownExpensesActualsPricePerDay: ?$ReadOnlyArray<?{|
        +milestoneId: string,
        +expenseCategoryBreakdown: ?$ReadOnlyArray<?{|
          +expenseCategoryId: string,
          +breakdown: ?$ReadOnlyArray<?{|
            +date: ?string,
            +value: ?number,
          |}>,
        |}>,
      |}>,
      +breakdownExpensesRemainingPricePerDay: ?$ReadOnlyArray<?{|
        +milestoneId: string,
        +expenseCategoryBreakdown: ?$ReadOnlyArray<?{|
          +expenseCategoryId: string,
          +breakdown: ?$ReadOnlyArray<?{|
            +date: ?string,
            +value: ?number,
          |}>,
        |}>,
      |}>,
      +breakdownExpensesPlannedCostPerDay: ?$ReadOnlyArray<?{|
        +milestoneId: string,
        +expenseCategoryBreakdown: ?$ReadOnlyArray<?{|
          +expenseCategoryId: string,
          +breakdown: ?$ReadOnlyArray<?{|
            +date: ?string,
            +value: ?number,
          |}>,
        |}>,
      |}>,
      +breakdownExpensesActualsCostPerDay: ?$ReadOnlyArray<?{|
        +milestoneId: string,
        +expenseCategoryBreakdown: ?$ReadOnlyArray<?{|
          +expenseCategoryId: string,
          +breakdown: ?$ReadOnlyArray<?{|
            +date: ?string,
            +value: ?number,
          |}>,
        |}>,
      |}>,
      +breakdownExpensesRemainingCostPerDay: ?$ReadOnlyArray<?{|
        +milestoneId: string,
        +expenseCategoryBreakdown: ?$ReadOnlyArray<?{|
          +expenseCategoryId: string,
          +breakdown: ?$ReadOnlyArray<?{|
            +date: ?string,
            +value: ?number,
          |}>,
        |}>,
      |}>,
      +baselineWinChance: ?number,
      +projectLabels: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +label: ?{|
              +id: string,
              +name: ?string,
              +color: ?string,
            |},
          |}
        |}>
      |},
      +client: ?{|
        +id: string,
        +name: ?string,
        +street: ?string,
        +vat: ?string,
        +zip: ?string,
        +city: ?string,
        +country: ?string,
        +notes: ?string,
        +logoId: ?string,
        +clientUsers: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +firstName: ?string,
              +lastName: ?string,
              +email: ?string,
              +userType: ?string,
              +phone: ?string,
            |}
          |}>
        |},
      |},
      +rateCard: ?{|
        +currency: ?string,
        +name: ?string,
        +defaultRate: ?number,
        +parentRateCardId: ?string,
        +rates: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +rate: ?number,
              +defaultRate: ?boolean,
              +startDate: ?string,
              +role: ?{|
                +id: string,
                +name: ?string,
              |},
            |}
          |}>
        |},
      |},
      +$fragmentRefs: ProjectSettingsPage_project$ref,
    |},
  |}
|};
export type updateProjectMutationModernMutation = {|
  variables: updateProjectMutationModernMutationVariables,
  response: updateProjectMutationModernMutationResponse,
|};
*/


/*
mutation updateProjectMutationModernMutation(
  $input: UpdateProjectInput!
) {
  updateProject(input: $input) {
    errors
    project {
      ...ProjectSettingsPage_project
      company {
        roles(first: 10000) {
          edges {
            node {
              id
              name
            }
          }
        }
        modules {
          moduleType
          id
        }
        expenseCategories(first: 10000) {
          edges {
            node {
              id
              name
            }
          }
        }
        id
      }
      xeroInvoices {
        id
        amountTotal
        amountNoTax
        amountPaid
      }
      invoices(first: 100000000) {
        edges {
          node {
            id
            name
            invoiceType
            status
            entries(first: 100000000) {
              edges {
                node {
                  id
                  name
                  quantity
                  unitPrice
                  discount
                  tax
                  description
                }
              }
            }
            payments(first: 100000000) {
              edges {
                node {
                  id
                  amount
                }
              }
            }
          }
        }
      }
      registeredMinutesPerDay(newBudget: true) {
        date
        value
      }
      remainingMinutesPerDay(newBudget: true) {
        date
        value
      }
      plannedMinutesPerDay(newBudget: true) {
        date
        value
      }
      costPlannedPerDay(newBudget: true) {
        date
        value
      }
      pricePlannedPerDay(newBudget: true) {
        date
        value
      }
      costRemainingPerDay(newBudget: true) {
        date
        value
      }
      priceRemainingPerDay(newBudget: true) {
        date
        value
      }
      costActualPerDay(newBudget: true) {
        date
        value
      }
      priceActualPerDay(newBudget: true) {
        date
        value
      }
      costPlannedWorkPerDay(newBudget: true) {
        date
        value
      }
      pricePlannedWorkPerDay(newBudget: true) {
        date
        value
      }
      costRemainingWorkPerDay(newBudget: true) {
        date
        value
      }
      priceRemainingWorkPerDay(newBudget: true) {
        date
        value
      }
      costActualWorkPerDay(newBudget: true) {
        date
        value
      }
      priceActualWorkPerDay(newBudget: true) {
        date
        value
      }
      pricePlannedExpensesPerDay(newBudget: true) {
        date
        value
      }
      costPlannedExpensesPerDay(newBudget: true) {
        date
        value
      }
      priceActualExpensesPerDay(newBudget: true) {
        date
        value
      }
      costActualExpensesPerDay(newBudget: true) {
        date
        value
      }
      priceRemainingExpensesPerDay(newBudget: true) {
        date
        value
      }
      costRemainingExpensesPerDay(newBudget: true) {
        date
        value
      }
      invoicedPerDay(newBudget: true) {
        date
        value
      }
      totalPaymentsPerDay(newBudget: true) {
        date
        value
      }
      baselinePricePerDay {
        date
        value
      }
      baselineCostPerDay {
        date
        value
      }
      baselineProfitPerDay {
        date
        value
      }
      baselineMinutesPerDay {
        date
        value
      }
      baselineUnplannedPricePerDay {
        date
        value
      }
      baselineUnplannedMinutesPerDay {
        date
        value
      }
      breakdownForecastMinutesPerDay {
        milestoneId
        roleBreakdown {
          roleId
          breakdown {
            date
            value
          }
        }
      }
      breakdownRemainingMinutesPerDay {
        milestoneId
        roleBreakdown {
          roleId
          breakdown {
            date
            value
          }
        }
      }
      breakdownActualMinutesPerDay {
        milestoneId
        roleBreakdown {
          roleId
          breakdown {
            date
            value
          }
        }
      }
      breakdownCostForecastPerDay {
        milestoneId
        roleBreakdown {
          roleId
          breakdown {
            date
            value
          }
        }
      }
      breakdownCostRemainingPerDay {
        milestoneId
        roleBreakdown {
          roleId
          breakdown {
            date
            value
          }
        }
      }
      breakdownCostActualPerDay {
        milestoneId
        roleBreakdown {
          roleId
          breakdown {
            date
            value
          }
        }
      }
      breakdownPricePlannedPerDay {
        milestoneId
        roleBreakdown {
          roleId
          breakdown {
            date
            value
          }
        }
      }
      breakdownPriceRemainingPerDay {
        milestoneId
        roleBreakdown {
          roleId
          breakdown {
            date
            value
          }
        }
      }
      breakdownPriceActualPerDay {
        milestoneId
        roleBreakdown {
          roleId
          breakdown {
            date
            value
          }
        }
      }
      breakdownCostForecastWorkPerDay {
        milestoneId
        roleBreakdown {
          roleId
          breakdown {
            date
            value
          }
        }
      }
      breakdownCostRemainingWorkPerDay {
        milestoneId
        roleBreakdown {
          roleId
          breakdown {
            date
            value
          }
        }
      }
      breakdownCostActualWorkPerDay {
        milestoneId
        roleBreakdown {
          roleId
          breakdown {
            date
            value
          }
        }
      }
      breakdownPricePlannedWorkPerDay {
        milestoneId
        roleBreakdown {
          roleId
          breakdown {
            date
            value
          }
        }
      }
      breakdownPriceRemainingWorkPerDay {
        milestoneId
        roleBreakdown {
          roleId
          breakdown {
            date
            value
          }
        }
      }
      breakdownPriceActualWorkPerDay {
        milestoneId
        roleBreakdown {
          roleId
          breakdown {
            date
            value
          }
        }
      }
      breakdownBaselinePricePerDay {
        milestoneId
        roleBreakdown {
          roleId
          breakdown {
            date
            value
          }
        }
      }
      breakdownBaselineCostPerDay {
        milestoneId
        roleBreakdown {
          roleId
          breakdown {
            date
            value
          }
        }
      }
      breakdownBaselineProfitPerDay {
        milestoneId
        roleBreakdown {
          roleId
          breakdown {
            date
            value
          }
        }
      }
      breakdownBaselineMinutesPerDay {
        milestoneId
        roleBreakdown {
          roleId
          breakdown {
            date
            value
          }
        }
      }
      breakdownBaselineExpensesPricePerDay {
        milestoneId
        expenseCategoryBreakdown {
          expenseCategoryId
          breakdown {
            date
            value
          }
        }
      }
      breakdownBaselineExpensesCostPerDay {
        milestoneId
        expenseCategoryBreakdown {
          expenseCategoryId
          breakdown {
            date
            value
          }
        }
      }
      breakdownExpensesPlannedPricePerDay {
        milestoneId
        expenseCategoryBreakdown {
          expenseCategoryId
          breakdown {
            date
            value
          }
        }
      }
      breakdownExpensesActualsPricePerDay {
        milestoneId
        expenseCategoryBreakdown {
          expenseCategoryId
          breakdown {
            date
            value
          }
        }
      }
      breakdownExpensesRemainingPricePerDay {
        milestoneId
        expenseCategoryBreakdown {
          expenseCategoryId
          breakdown {
            date
            value
          }
        }
      }
      breakdownExpensesPlannedCostPerDay {
        milestoneId
        expenseCategoryBreakdown {
          expenseCategoryId
          breakdown {
            date
            value
          }
        }
      }
      breakdownExpensesActualsCostPerDay {
        milestoneId
        expenseCategoryBreakdown {
          expenseCategoryId
          breakdown {
            date
            value
          }
        }
      }
      breakdownExpensesRemainingCostPerDay {
        milestoneId
        expenseCategoryBreakdown {
          expenseCategoryId
          breakdown {
            date
            value
          }
        }
      }
      baselineWinChance
      projectLabels(first: 10000) {
        edges {
          node {
            id
            label {
              id
              name
              color
            }
          }
        }
      }
      client {
        id
        name
        street
        vat
        zip
        city
        country
        notes
        logoId
        clientUsers(first: 1000) {
          edges {
            node {
              id
              firstName
              lastName
              email
              userType
              phone
            }
          }
        }
      }
      rateCard {
        currency
        name
        defaultRate
        parentRateCardId
        rates(first: 10000) {
          edges {
            node {
              id
              rate
              defaultRate
              startDate
              role {
                id
                name
              }
            }
          }
        }
        id
      }
      id
    }
  }
}

fragment ProjectSettingsPage_project on ProjectType {
  id
  companyProjectId
  isInProjectGroup
  projectGroupId
  name
  budgetType
  budget
  useBaseline
  defaultPeriodPeriodicity
  defaultPeriodLength
  defaultPeriodBudgetType
  defaultPeriodHoursAmount
  defaultPeriodPriceAmount
  defaultPeriodSettingSubtractValue
  defaultPeriodSettingRollValue
  githubRepositoryIds
  useManualAllocations
  taskCostCalculationType
  unassignedTaskHourlyCost
  linkToPublicCreateTaskPage
  usePublicCreateTaskPassword
  publicCreateTaskPassword
  publicCreateTaskPageStatusColumn {
    id
    name
  }
  hasInvoices
  hasLockedPeriod
  hasLockedTime
  baselineWinChance
  teamsId
  currentProjectStatus {
    id
    color
    description
    day
    month
    year
    person {
      id
      firstName
      lastName
      profilePictureId
    }
  }
  timelogProject {
    id
  }
  harvestProject {
    id
  }
  harvestProjectId
  jiraCloudProject {
    id
    name
  }
  jiraCloudEpics {
    id
    key
  }
  jiraServerProject {
    id
    name
  }
  isJiraProject
  slackChannel {
    id
  }
  salesforceOpportunity
  unit4Project {
    id
    name
  }
  hubspotDeal
  pipedriveDeal
  vstsProject
  vstsAccount
  vstsArea
  vstsSyncBugs
  vstsTwoWaySync
  vstsUseEpics
  vstsUseNewSubtasks
  gitlabProjectId
  gitlabProjectName
  gitlabServerProjectId
  gitlabServerProjectName
  gitHubSyncTarget
  status
  projectColor
  statusColumnsV2(first: 1000000) {
    edges {
      node {
        id
        category
        name
      }
    }
  }
  projectLabels(first: 10000) {
    edges {
      node {
        id
        label {
          id
          name
          color
        }
      }
    }
  }
  description
  estimationUnit
  sprintTimeBox
  sprintLengthInDays
  projectStartYear
  projectStartMonth
  projectStartDay
  projectEndYear
  projectEndMonth
  projectEndDay
  taskLevels
  useTaskHierarchy
  minutesPerEstimationPoint
  billable
  remainingAutoCalculated
  useTaskOwner
  useTaskFollowers
  retainerPeriods(first: 1) {
    edges {
      node {
        id
      }
    }
  }
  projectPersons(first: 10000) {
    edges {
      node {
        id
        isContactPerson
        role {
          id
          name
        }
        person {
          id
          firstName
          lastName
          fullName
          initials
          userType
          profileId
          permissions
          email
          profilePictureId
          profilePictureDefaultId
          active
          isViewer
          harvestUser
          role {
            id
            name
          }
          personLabels(first: 1000) {
            edges {
              node {
                id
                label {
                  id
                  name
                }
              }
            }
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  rateCard {
    id
    currency
  }
  invoices(first: 100000000) {
    edges {
      node {
        status
        id
      }
    }
  }
  client {
    id
  }
  tasks(first: 100000) {
    edges {
      node {
        id
        name
        companyTaskId
        statusColumnV2 {
          name
          category
          id
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateProjectInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = [
  (v4/*: any*/),
  (v5/*: any*/)
],
v7 = {
  "alias": null,
  "args": (v3/*: any*/),
  "concreteType": "RoleTypeConnection",
  "kind": "LinkedField",
  "name": "roles",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RoleTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Role",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v6/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "roles(first:10000)"
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "moduleType",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": (v3/*: any*/),
  "concreteType": "ExpenseCategoryTypeConnection",
  "kind": "LinkedField",
  "name": "expenseCategories",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ExpenseCategoryTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ExpenseCategory",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v6/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "expenseCategories(first:10000)"
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "XeroInvoiceType",
  "kind": "LinkedField",
  "name": "xeroInvoices",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amountTotal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amountNoTax",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amountPaid",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100000000
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiceType",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": (v11/*: any*/),
  "concreteType": "InvoiceEntryTypeConnection",
  "kind": "LinkedField",
  "name": "entries",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "InvoiceEntryTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "InvoiceEntryType",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v5/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "quantity",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "unitPrice",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "discount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tax",
              "storageKey": null
            },
            (v14/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "entries(first:100000000)"
},
v16 = {
  "alias": null,
  "args": (v11/*: any*/),
  "concreteType": "InvoicePaymentTypeConnection",
  "kind": "LinkedField",
  "name": "payments",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "InvoicePaymentTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "InvoicePaymentType",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "amount",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "payments(first:100000000)"
},
v17 = [
  {
    "kind": "Literal",
    "name": "newBudget",
    "value": true
  }
],
v18 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "date",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
],
v19 = {
  "alias": null,
  "args": (v17/*: any*/),
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "registeredMinutesPerDay",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": "registeredMinutesPerDay(newBudget:true)"
},
v20 = {
  "alias": null,
  "args": (v17/*: any*/),
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "remainingMinutesPerDay",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": "remainingMinutesPerDay(newBudget:true)"
},
v21 = {
  "alias": null,
  "args": (v17/*: any*/),
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "plannedMinutesPerDay",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": "plannedMinutesPerDay(newBudget:true)"
},
v22 = {
  "alias": null,
  "args": (v17/*: any*/),
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "costPlannedPerDay",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": "costPlannedPerDay(newBudget:true)"
},
v23 = {
  "alias": null,
  "args": (v17/*: any*/),
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "pricePlannedPerDay",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": "pricePlannedPerDay(newBudget:true)"
},
v24 = {
  "alias": null,
  "args": (v17/*: any*/),
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "costRemainingPerDay",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": "costRemainingPerDay(newBudget:true)"
},
v25 = {
  "alias": null,
  "args": (v17/*: any*/),
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "priceRemainingPerDay",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": "priceRemainingPerDay(newBudget:true)"
},
v26 = {
  "alias": null,
  "args": (v17/*: any*/),
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "costActualPerDay",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": "costActualPerDay(newBudget:true)"
},
v27 = {
  "alias": null,
  "args": (v17/*: any*/),
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "priceActualPerDay",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": "priceActualPerDay(newBudget:true)"
},
v28 = {
  "alias": null,
  "args": (v17/*: any*/),
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "costPlannedWorkPerDay",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": "costPlannedWorkPerDay(newBudget:true)"
},
v29 = {
  "alias": null,
  "args": (v17/*: any*/),
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "pricePlannedWorkPerDay",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": "pricePlannedWorkPerDay(newBudget:true)"
},
v30 = {
  "alias": null,
  "args": (v17/*: any*/),
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "costRemainingWorkPerDay",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": "costRemainingWorkPerDay(newBudget:true)"
},
v31 = {
  "alias": null,
  "args": (v17/*: any*/),
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "priceRemainingWorkPerDay",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": "priceRemainingWorkPerDay(newBudget:true)"
},
v32 = {
  "alias": null,
  "args": (v17/*: any*/),
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "costActualWorkPerDay",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": "costActualWorkPerDay(newBudget:true)"
},
v33 = {
  "alias": null,
  "args": (v17/*: any*/),
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "priceActualWorkPerDay",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": "priceActualWorkPerDay(newBudget:true)"
},
v34 = {
  "alias": null,
  "args": (v17/*: any*/),
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "pricePlannedExpensesPerDay",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": "pricePlannedExpensesPerDay(newBudget:true)"
},
v35 = {
  "alias": null,
  "args": (v17/*: any*/),
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "costPlannedExpensesPerDay",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": "costPlannedExpensesPerDay(newBudget:true)"
},
v36 = {
  "alias": null,
  "args": (v17/*: any*/),
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "priceActualExpensesPerDay",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": "priceActualExpensesPerDay(newBudget:true)"
},
v37 = {
  "alias": null,
  "args": (v17/*: any*/),
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "costActualExpensesPerDay",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": "costActualExpensesPerDay(newBudget:true)"
},
v38 = {
  "alias": null,
  "args": (v17/*: any*/),
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "priceRemainingExpensesPerDay",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": "priceRemainingExpensesPerDay(newBudget:true)"
},
v39 = {
  "alias": null,
  "args": (v17/*: any*/),
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "costRemainingExpensesPerDay",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": "costRemainingExpensesPerDay(newBudget:true)"
},
v40 = {
  "alias": null,
  "args": (v17/*: any*/),
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "invoicedPerDay",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": "invoicedPerDay(newBudget:true)"
},
v41 = {
  "alias": null,
  "args": (v17/*: any*/),
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "totalPaymentsPerDay",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": "totalPaymentsPerDay(newBudget:true)"
},
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "baselinePricePerDay",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "baselineCostPerDay",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "baselineProfitPerDay",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "baselineMinutesPerDay",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "baselineUnplannedPricePerDay",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "baselineUnplannedMinutesPerDay",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "milestoneId",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "concreteType": "DateValueType",
  "kind": "LinkedField",
  "name": "breakdown",
  "plural": true,
  "selections": (v18/*: any*/),
  "storageKey": null
},
v50 = [
  (v48/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "BudgetRoleBreakdownType",
    "kind": "LinkedField",
    "name": "roleBreakdown",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "roleId",
        "storageKey": null
      },
      (v49/*: any*/)
    ],
    "storageKey": null
  }
],
v51 = {
  "alias": null,
  "args": null,
  "concreteType": "BudgetMilestoneBreakdownType",
  "kind": "LinkedField",
  "name": "breakdownForecastMinutesPerDay",
  "plural": true,
  "selections": (v50/*: any*/),
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "concreteType": "BudgetMilestoneBreakdownType",
  "kind": "LinkedField",
  "name": "breakdownRemainingMinutesPerDay",
  "plural": true,
  "selections": (v50/*: any*/),
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "concreteType": "BudgetMilestoneBreakdownType",
  "kind": "LinkedField",
  "name": "breakdownActualMinutesPerDay",
  "plural": true,
  "selections": (v50/*: any*/),
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "concreteType": "BudgetMilestoneBreakdownType",
  "kind": "LinkedField",
  "name": "breakdownCostForecastPerDay",
  "plural": true,
  "selections": (v50/*: any*/),
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "concreteType": "BudgetMilestoneBreakdownType",
  "kind": "LinkedField",
  "name": "breakdownCostRemainingPerDay",
  "plural": true,
  "selections": (v50/*: any*/),
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "BudgetMilestoneBreakdownType",
  "kind": "LinkedField",
  "name": "breakdownCostActualPerDay",
  "plural": true,
  "selections": (v50/*: any*/),
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "concreteType": "BudgetMilestoneBreakdownType",
  "kind": "LinkedField",
  "name": "breakdownPricePlannedPerDay",
  "plural": true,
  "selections": (v50/*: any*/),
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "concreteType": "BudgetMilestoneBreakdownType",
  "kind": "LinkedField",
  "name": "breakdownPriceRemainingPerDay",
  "plural": true,
  "selections": (v50/*: any*/),
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "concreteType": "BudgetMilestoneBreakdownType",
  "kind": "LinkedField",
  "name": "breakdownPriceActualPerDay",
  "plural": true,
  "selections": (v50/*: any*/),
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "concreteType": "BudgetMilestoneBreakdownType",
  "kind": "LinkedField",
  "name": "breakdownCostForecastWorkPerDay",
  "plural": true,
  "selections": (v50/*: any*/),
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "concreteType": "BudgetMilestoneBreakdownType",
  "kind": "LinkedField",
  "name": "breakdownCostRemainingWorkPerDay",
  "plural": true,
  "selections": (v50/*: any*/),
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "concreteType": "BudgetMilestoneBreakdownType",
  "kind": "LinkedField",
  "name": "breakdownCostActualWorkPerDay",
  "plural": true,
  "selections": (v50/*: any*/),
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "concreteType": "BudgetMilestoneBreakdownType",
  "kind": "LinkedField",
  "name": "breakdownPricePlannedWorkPerDay",
  "plural": true,
  "selections": (v50/*: any*/),
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "concreteType": "BudgetMilestoneBreakdownType",
  "kind": "LinkedField",
  "name": "breakdownPriceRemainingWorkPerDay",
  "plural": true,
  "selections": (v50/*: any*/),
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "concreteType": "BudgetMilestoneBreakdownType",
  "kind": "LinkedField",
  "name": "breakdownPriceActualWorkPerDay",
  "plural": true,
  "selections": (v50/*: any*/),
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "concreteType": "BudgetMilestoneBreakdownType",
  "kind": "LinkedField",
  "name": "breakdownBaselinePricePerDay",
  "plural": true,
  "selections": (v50/*: any*/),
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "concreteType": "BudgetMilestoneBreakdownType",
  "kind": "LinkedField",
  "name": "breakdownBaselineCostPerDay",
  "plural": true,
  "selections": (v50/*: any*/),
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "concreteType": "BudgetMilestoneBreakdownType",
  "kind": "LinkedField",
  "name": "breakdownBaselineProfitPerDay",
  "plural": true,
  "selections": (v50/*: any*/),
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "concreteType": "BudgetMilestoneBreakdownType",
  "kind": "LinkedField",
  "name": "breakdownBaselineMinutesPerDay",
  "plural": true,
  "selections": (v50/*: any*/),
  "storageKey": null
},
v70 = [
  (v48/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "BudgetExpenseCategoryBreakdownType",
    "kind": "LinkedField",
    "name": "expenseCategoryBreakdown",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expenseCategoryId",
        "storageKey": null
      },
      (v49/*: any*/)
    ],
    "storageKey": null
  }
],
v71 = {
  "alias": null,
  "args": null,
  "concreteType": "BudgetMilestoneExpenseCategoryBreakdownType",
  "kind": "LinkedField",
  "name": "breakdownBaselineExpensesPricePerDay",
  "plural": true,
  "selections": (v70/*: any*/),
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "concreteType": "BudgetMilestoneExpenseCategoryBreakdownType",
  "kind": "LinkedField",
  "name": "breakdownBaselineExpensesCostPerDay",
  "plural": true,
  "selections": (v70/*: any*/),
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "concreteType": "BudgetMilestoneExpenseCategoryBreakdownType",
  "kind": "LinkedField",
  "name": "breakdownExpensesPlannedPricePerDay",
  "plural": true,
  "selections": (v70/*: any*/),
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "concreteType": "BudgetMilestoneExpenseCategoryBreakdownType",
  "kind": "LinkedField",
  "name": "breakdownExpensesActualsPricePerDay",
  "plural": true,
  "selections": (v70/*: any*/),
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "concreteType": "BudgetMilestoneExpenseCategoryBreakdownType",
  "kind": "LinkedField",
  "name": "breakdownExpensesRemainingPricePerDay",
  "plural": true,
  "selections": (v70/*: any*/),
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "concreteType": "BudgetMilestoneExpenseCategoryBreakdownType",
  "kind": "LinkedField",
  "name": "breakdownExpensesPlannedCostPerDay",
  "plural": true,
  "selections": (v70/*: any*/),
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "concreteType": "BudgetMilestoneExpenseCategoryBreakdownType",
  "kind": "LinkedField",
  "name": "breakdownExpensesActualsCostPerDay",
  "plural": true,
  "selections": (v70/*: any*/),
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "concreteType": "BudgetMilestoneExpenseCategoryBreakdownType",
  "kind": "LinkedField",
  "name": "breakdownExpensesRemainingCostPerDay",
  "plural": true,
  "selections": (v70/*: any*/),
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineWinChance",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": (v3/*: any*/),
  "concreteType": "ProjectLabelTypeConnection",
  "kind": "LinkedField",
  "name": "projectLabels",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectLabelTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectLabel",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Label",
              "kind": "LinkedField",
              "name": "label",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                (v5/*: any*/),
                (v80/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "projectLabels(first:10000)"
},
v82 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userType",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "concreteType": "Client",
  "kind": "LinkedField",
  "name": "client",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "street",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vat",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "zip",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "city",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "country",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v82/*: any*/),
      "concreteType": "PersonTypeConnection",
      "kind": "LinkedField",
      "name": "clientUsers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PersonTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Person",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                (v83/*: any*/),
                (v84/*: any*/),
                (v85/*: any*/),
                (v86/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "phone",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "clientUsers(first:1000)"
    }
  ],
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultRate",
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentRateCardId",
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": (v3/*: any*/),
  "concreteType": "RateTypeConnection",
  "kind": "LinkedField",
  "name": "rates",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RateTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Rate",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rate",
              "storageKey": null
            },
            (v89/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startDate",
              "storageKey": null
            },
            (v91/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "rates(first:10000)"
},
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v94 = [
  (v4/*: any*/)
],
v95 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateProjectMutationModernMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateProjectPayload",
        "kind": "LinkedField",
        "name": "updateProject",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Company",
                "kind": "LinkedField",
                "name": "company",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Module",
                    "kind": "LinkedField",
                    "name": "modules",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              (v10/*: any*/),
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "InvoiceTypeConnection",
                "kind": "LinkedField",
                "name": "invoices",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InvoiceTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InvoiceType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "invoices(first:100000000)"
              },
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v43/*: any*/),
              (v44/*: any*/),
              (v45/*: any*/),
              (v46/*: any*/),
              (v47/*: any*/),
              (v51/*: any*/),
              (v52/*: any*/),
              (v53/*: any*/),
              (v54/*: any*/),
              (v55/*: any*/),
              (v56/*: any*/),
              (v57/*: any*/),
              (v58/*: any*/),
              (v59/*: any*/),
              (v60/*: any*/),
              (v61/*: any*/),
              (v62/*: any*/),
              (v63/*: any*/),
              (v64/*: any*/),
              (v65/*: any*/),
              (v66/*: any*/),
              (v67/*: any*/),
              (v68/*: any*/),
              (v69/*: any*/),
              (v71/*: any*/),
              (v72/*: any*/),
              (v73/*: any*/),
              (v74/*: any*/),
              (v75/*: any*/),
              (v76/*: any*/),
              (v77/*: any*/),
              (v78/*: any*/),
              (v79/*: any*/),
              (v81/*: any*/),
              (v87/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RateCard",
                "kind": "LinkedField",
                "name": "rateCard",
                "plural": false,
                "selections": [
                  (v88/*: any*/),
                  (v5/*: any*/),
                  (v89/*: any*/),
                  (v90/*: any*/),
                  (v92/*: any*/)
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProjectSettingsPage_project"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateProjectMutationModernMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateProjectPayload",
        "kind": "LinkedField",
        "name": "updateProject",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "companyProjectId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isInProjectGroup",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupId",
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "budgetType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "budget",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useBaseline",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultPeriodPeriodicity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultPeriodLength",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultPeriodBudgetType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultPeriodHoursAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultPeriodPriceAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultPeriodSettingSubtractValue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultPeriodSettingRollValue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "githubRepositoryIds",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useManualAllocations",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "taskCostCalculationType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unassignedTaskHourlyCost",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "linkToPublicCreateTaskPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "usePublicCreateTaskPassword",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "publicCreateTaskPassword",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StatusColumnV2",
                "kind": "LinkedField",
                "name": "publicCreateTaskPageStatusColumn",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasInvoices",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasLockedPeriod",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasLockedTime",
                "storageKey": null
              },
              (v79/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "teamsId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectStatus",
                "kind": "LinkedField",
                "name": "currentProjectStatus",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v80/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "day",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "month",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "year",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Person",
                    "kind": "LinkedField",
                    "name": "person",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v83/*: any*/),
                      (v84/*: any*/),
                      (v93/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TimelogProjectType",
                "kind": "LinkedField",
                "name": "timelogProject",
                "plural": false,
                "selections": (v94/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "HarvestProjectType",
                "kind": "LinkedField",
                "name": "harvestProject",
                "plural": false,
                "selections": (v94/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "harvestProjectId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraCloudProjectType",
                "kind": "LinkedField",
                "name": "jiraCloudProject",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraCloudIssueType",
                "kind": "LinkedField",
                "name": "jiraCloudEpics",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraServerProjectType",
                "kind": "LinkedField",
                "name": "jiraServerProject",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isJiraProject",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SlackChannelType",
                "kind": "LinkedField",
                "name": "slackChannel",
                "plural": false,
                "selections": (v94/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "salesforceOpportunity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Unit4ProjectType",
                "kind": "LinkedField",
                "name": "unit4Project",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hubspotDeal",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pipedriveDeal",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vstsProject",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vstsAccount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vstsArea",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vstsSyncBugs",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vstsTwoWaySync",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vstsUseEpics",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vstsUseNewSubtasks",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gitlabProjectId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gitlabProjectName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gitlabServerProjectId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gitlabServerProjectName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gitHubSyncTarget",
                "storageKey": null
              },
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000000
                  }
                ],
                "concreteType": "StatusColumnV2TypeConnection",
                "kind": "LinkedField",
                "name": "statusColumnsV2",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StatusColumnV2TypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StatusColumnV2",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v95/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "statusColumnsV2(first:1000000)"
              },
              (v81/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "estimationUnit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sprintTimeBox",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sprintLengthInDays",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectStartYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectStartMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectStartDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectEndYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectEndMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectEndDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "taskLevels",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useTaskHierarchy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minutesPerEstimationPoint",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "billable",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "remainingAutoCalculated",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useTaskOwner",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useTaskFollowers",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  }
                ],
                "concreteType": "RetainerPeriodTypeConnection",
                "kind": "LinkedField",
                "name": "retainerPeriods",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RetainerPeriodTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RetainerPeriodType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v94/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "retainerPeriods(first:1)"
              },
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "ProjectPersonTypeConnection",
                "kind": "LinkedField",
                "name": "projectPersons",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectPersonTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectPerson",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isContactPerson",
                            "storageKey": null
                          },
                          (v91/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "person",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v83/*: any*/),
                              (v84/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "fullName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "initials",
                                "storageKey": null
                              },
                              (v86/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "profileId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "permissions",
                                "storageKey": null
                              },
                              (v85/*: any*/),
                              (v93/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "profilePictureDefaultId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "active",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isViewer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "harvestUser",
                                "storageKey": null
                              },
                              (v91/*: any*/),
                              {
                                "alias": null,
                                "args": (v82/*: any*/),
                                "concreteType": "PersonLabelTypeConnection",
                                "kind": "LinkedField",
                                "name": "personLabels",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PersonLabelTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "PersonLabel",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v4/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Label",
                                            "kind": "LinkedField",
                                            "name": "label",
                                            "plural": false,
                                            "selections": (v6/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "personLabels(first:1000)"
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "projectPersons(first:10000)"
              },
              {
                "alias": null,
                "args": (v3/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "Project_projectPersons",
                "kind": "LinkedHandle",
                "name": "projectPersons"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RateCard",
                "kind": "LinkedField",
                "name": "rateCard",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v88/*: any*/),
                  (v5/*: any*/),
                  (v89/*: any*/),
                  (v90/*: any*/),
                  (v92/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "InvoiceTypeConnection",
                "kind": "LinkedField",
                "name": "invoices",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InvoiceTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InvoiceType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v12/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "invoices(first:100000000)"
              },
              (v87/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 100000
                  }
                ],
                "concreteType": "TaskTypeConnection",
                "kind": "LinkedField",
                "name": "tasks",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaskTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Task",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "companyTaskId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StatusColumnV2",
                            "kind": "LinkedField",
                            "name": "statusColumnV2",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v95/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "tasks(first:100000)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Company",
                "kind": "LinkedField",
                "name": "company",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Module",
                    "kind": "LinkedField",
                    "name": "modules",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v10/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v43/*: any*/),
              (v44/*: any*/),
              (v45/*: any*/),
              (v46/*: any*/),
              (v47/*: any*/),
              (v51/*: any*/),
              (v52/*: any*/),
              (v53/*: any*/),
              (v54/*: any*/),
              (v55/*: any*/),
              (v56/*: any*/),
              (v57/*: any*/),
              (v58/*: any*/),
              (v59/*: any*/),
              (v60/*: any*/),
              (v61/*: any*/),
              (v62/*: any*/),
              (v63/*: any*/),
              (v64/*: any*/),
              (v65/*: any*/),
              (v66/*: any*/),
              (v67/*: any*/),
              (v68/*: any*/),
              (v69/*: any*/),
              (v71/*: any*/),
              (v72/*: any*/),
              (v73/*: any*/),
              (v74/*: any*/),
              (v75/*: any*/),
              (v76/*: any*/),
              (v77/*: any*/),
              (v78/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateProjectMutationModernMutation",
    "operationKind": "mutation",
    "text": "mutation updateProjectMutationModernMutation(\n  $input: UpdateProjectInput!\n) {\n  updateProject(input: $input) {\n    errors\n    project {\n      ...ProjectSettingsPage_project\n      company {\n        roles(first: 10000) {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        modules {\n          moduleType\n          id\n        }\n        expenseCategories(first: 10000) {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        id\n      }\n      xeroInvoices {\n        id\n        amountTotal\n        amountNoTax\n        amountPaid\n      }\n      invoices(first: 100000000) {\n        edges {\n          node {\n            id\n            name\n            invoiceType\n            status\n            entries(first: 100000000) {\n              edges {\n                node {\n                  id\n                  name\n                  quantity\n                  unitPrice\n                  discount\n                  tax\n                  description\n                }\n              }\n            }\n            payments(first: 100000000) {\n              edges {\n                node {\n                  id\n                  amount\n                }\n              }\n            }\n          }\n        }\n      }\n      registeredMinutesPerDay(newBudget: true) {\n        date\n        value\n      }\n      remainingMinutesPerDay(newBudget: true) {\n        date\n        value\n      }\n      plannedMinutesPerDay(newBudget: true) {\n        date\n        value\n      }\n      costPlannedPerDay(newBudget: true) {\n        date\n        value\n      }\n      pricePlannedPerDay(newBudget: true) {\n        date\n        value\n      }\n      costRemainingPerDay(newBudget: true) {\n        date\n        value\n      }\n      priceRemainingPerDay(newBudget: true) {\n        date\n        value\n      }\n      costActualPerDay(newBudget: true) {\n        date\n        value\n      }\n      priceActualPerDay(newBudget: true) {\n        date\n        value\n      }\n      costPlannedWorkPerDay(newBudget: true) {\n        date\n        value\n      }\n      pricePlannedWorkPerDay(newBudget: true) {\n        date\n        value\n      }\n      costRemainingWorkPerDay(newBudget: true) {\n        date\n        value\n      }\n      priceRemainingWorkPerDay(newBudget: true) {\n        date\n        value\n      }\n      costActualWorkPerDay(newBudget: true) {\n        date\n        value\n      }\n      priceActualWorkPerDay(newBudget: true) {\n        date\n        value\n      }\n      pricePlannedExpensesPerDay(newBudget: true) {\n        date\n        value\n      }\n      costPlannedExpensesPerDay(newBudget: true) {\n        date\n        value\n      }\n      priceActualExpensesPerDay(newBudget: true) {\n        date\n        value\n      }\n      costActualExpensesPerDay(newBudget: true) {\n        date\n        value\n      }\n      priceRemainingExpensesPerDay(newBudget: true) {\n        date\n        value\n      }\n      costRemainingExpensesPerDay(newBudget: true) {\n        date\n        value\n      }\n      invoicedPerDay(newBudget: true) {\n        date\n        value\n      }\n      totalPaymentsPerDay(newBudget: true) {\n        date\n        value\n      }\n      baselinePricePerDay {\n        date\n        value\n      }\n      baselineCostPerDay {\n        date\n        value\n      }\n      baselineProfitPerDay {\n        date\n        value\n      }\n      baselineMinutesPerDay {\n        date\n        value\n      }\n      baselineUnplannedPricePerDay {\n        date\n        value\n      }\n      baselineUnplannedMinutesPerDay {\n        date\n        value\n      }\n      breakdownForecastMinutesPerDay {\n        milestoneId\n        roleBreakdown {\n          roleId\n          breakdown {\n            date\n            value\n          }\n        }\n      }\n      breakdownRemainingMinutesPerDay {\n        milestoneId\n        roleBreakdown {\n          roleId\n          breakdown {\n            date\n            value\n          }\n        }\n      }\n      breakdownActualMinutesPerDay {\n        milestoneId\n        roleBreakdown {\n          roleId\n          breakdown {\n            date\n            value\n          }\n        }\n      }\n      breakdownCostForecastPerDay {\n        milestoneId\n        roleBreakdown {\n          roleId\n          breakdown {\n            date\n            value\n          }\n        }\n      }\n      breakdownCostRemainingPerDay {\n        milestoneId\n        roleBreakdown {\n          roleId\n          breakdown {\n            date\n            value\n          }\n        }\n      }\n      breakdownCostActualPerDay {\n        milestoneId\n        roleBreakdown {\n          roleId\n          breakdown {\n            date\n            value\n          }\n        }\n      }\n      breakdownPricePlannedPerDay {\n        milestoneId\n        roleBreakdown {\n          roleId\n          breakdown {\n            date\n            value\n          }\n        }\n      }\n      breakdownPriceRemainingPerDay {\n        milestoneId\n        roleBreakdown {\n          roleId\n          breakdown {\n            date\n            value\n          }\n        }\n      }\n      breakdownPriceActualPerDay {\n        milestoneId\n        roleBreakdown {\n          roleId\n          breakdown {\n            date\n            value\n          }\n        }\n      }\n      breakdownCostForecastWorkPerDay {\n        milestoneId\n        roleBreakdown {\n          roleId\n          breakdown {\n            date\n            value\n          }\n        }\n      }\n      breakdownCostRemainingWorkPerDay {\n        milestoneId\n        roleBreakdown {\n          roleId\n          breakdown {\n            date\n            value\n          }\n        }\n      }\n      breakdownCostActualWorkPerDay {\n        milestoneId\n        roleBreakdown {\n          roleId\n          breakdown {\n            date\n            value\n          }\n        }\n      }\n      breakdownPricePlannedWorkPerDay {\n        milestoneId\n        roleBreakdown {\n          roleId\n          breakdown {\n            date\n            value\n          }\n        }\n      }\n      breakdownPriceRemainingWorkPerDay {\n        milestoneId\n        roleBreakdown {\n          roleId\n          breakdown {\n            date\n            value\n          }\n        }\n      }\n      breakdownPriceActualWorkPerDay {\n        milestoneId\n        roleBreakdown {\n          roleId\n          breakdown {\n            date\n            value\n          }\n        }\n      }\n      breakdownBaselinePricePerDay {\n        milestoneId\n        roleBreakdown {\n          roleId\n          breakdown {\n            date\n            value\n          }\n        }\n      }\n      breakdownBaselineCostPerDay {\n        milestoneId\n        roleBreakdown {\n          roleId\n          breakdown {\n            date\n            value\n          }\n        }\n      }\n      breakdownBaselineProfitPerDay {\n        milestoneId\n        roleBreakdown {\n          roleId\n          breakdown {\n            date\n            value\n          }\n        }\n      }\n      breakdownBaselineMinutesPerDay {\n        milestoneId\n        roleBreakdown {\n          roleId\n          breakdown {\n            date\n            value\n          }\n        }\n      }\n      breakdownBaselineExpensesPricePerDay {\n        milestoneId\n        expenseCategoryBreakdown {\n          expenseCategoryId\n          breakdown {\n            date\n            value\n          }\n        }\n      }\n      breakdownBaselineExpensesCostPerDay {\n        milestoneId\n        expenseCategoryBreakdown {\n          expenseCategoryId\n          breakdown {\n            date\n            value\n          }\n        }\n      }\n      breakdownExpensesPlannedPricePerDay {\n        milestoneId\n        expenseCategoryBreakdown {\n          expenseCategoryId\n          breakdown {\n            date\n            value\n          }\n        }\n      }\n      breakdownExpensesActualsPricePerDay {\n        milestoneId\n        expenseCategoryBreakdown {\n          expenseCategoryId\n          breakdown {\n            date\n            value\n          }\n        }\n      }\n      breakdownExpensesRemainingPricePerDay {\n        milestoneId\n        expenseCategoryBreakdown {\n          expenseCategoryId\n          breakdown {\n            date\n            value\n          }\n        }\n      }\n      breakdownExpensesPlannedCostPerDay {\n        milestoneId\n        expenseCategoryBreakdown {\n          expenseCategoryId\n          breakdown {\n            date\n            value\n          }\n        }\n      }\n      breakdownExpensesActualsCostPerDay {\n        milestoneId\n        expenseCategoryBreakdown {\n          expenseCategoryId\n          breakdown {\n            date\n            value\n          }\n        }\n      }\n      breakdownExpensesRemainingCostPerDay {\n        milestoneId\n        expenseCategoryBreakdown {\n          expenseCategoryId\n          breakdown {\n            date\n            value\n          }\n        }\n      }\n      baselineWinChance\n      projectLabels(first: 10000) {\n        edges {\n          node {\n            id\n            label {\n              id\n              name\n              color\n            }\n          }\n        }\n      }\n      client {\n        id\n        name\n        street\n        vat\n        zip\n        city\n        country\n        notes\n        logoId\n        clientUsers(first: 1000) {\n          edges {\n            node {\n              id\n              firstName\n              lastName\n              email\n              userType\n              phone\n            }\n          }\n        }\n      }\n      rateCard {\n        currency\n        name\n        defaultRate\n        parentRateCardId\n        rates(first: 10000) {\n          edges {\n            node {\n              id\n              rate\n              defaultRate\n              startDate\n              role {\n                id\n                name\n              }\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment ProjectSettingsPage_project on ProjectType {\n  id\n  companyProjectId\n  isInProjectGroup\n  projectGroupId\n  name\n  budgetType\n  budget\n  useBaseline\n  defaultPeriodPeriodicity\n  defaultPeriodLength\n  defaultPeriodBudgetType\n  defaultPeriodHoursAmount\n  defaultPeriodPriceAmount\n  defaultPeriodSettingSubtractValue\n  defaultPeriodSettingRollValue\n  githubRepositoryIds\n  useManualAllocations\n  taskCostCalculationType\n  unassignedTaskHourlyCost\n  linkToPublicCreateTaskPage\n  usePublicCreateTaskPassword\n  publicCreateTaskPassword\n  publicCreateTaskPageStatusColumn {\n    id\n    name\n  }\n  hasInvoices\n  hasLockedPeriod\n  hasLockedTime\n  baselineWinChance\n  teamsId\n  currentProjectStatus {\n    id\n    color\n    description\n    day\n    month\n    year\n    person {\n      id\n      firstName\n      lastName\n      profilePictureId\n    }\n  }\n  timelogProject {\n    id\n  }\n  harvestProject {\n    id\n  }\n  harvestProjectId\n  jiraCloudProject {\n    id\n    name\n  }\n  jiraCloudEpics {\n    id\n    key\n  }\n  jiraServerProject {\n    id\n    name\n  }\n  isJiraProject\n  slackChannel {\n    id\n  }\n  salesforceOpportunity\n  unit4Project {\n    id\n    name\n  }\n  hubspotDeal\n  pipedriveDeal\n  vstsProject\n  vstsAccount\n  vstsArea\n  vstsSyncBugs\n  vstsTwoWaySync\n  vstsUseEpics\n  vstsUseNewSubtasks\n  gitlabProjectId\n  gitlabProjectName\n  gitlabServerProjectId\n  gitlabServerProjectName\n  gitHubSyncTarget\n  status\n  projectColor\n  statusColumnsV2(first: 1000000) {\n    edges {\n      node {\n        id\n        category\n        name\n      }\n    }\n  }\n  projectLabels(first: 10000) {\n    edges {\n      node {\n        id\n        label {\n          id\n          name\n          color\n        }\n      }\n    }\n  }\n  description\n  estimationUnit\n  sprintTimeBox\n  sprintLengthInDays\n  projectStartYear\n  projectStartMonth\n  projectStartDay\n  projectEndYear\n  projectEndMonth\n  projectEndDay\n  taskLevels\n  useTaskHierarchy\n  minutesPerEstimationPoint\n  billable\n  remainingAutoCalculated\n  useTaskOwner\n  useTaskFollowers\n  retainerPeriods(first: 1) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  projectPersons(first: 10000) {\n    edges {\n      node {\n        id\n        isContactPerson\n        role {\n          id\n          name\n        }\n        person {\n          id\n          firstName\n          lastName\n          fullName\n          initials\n          userType\n          profileId\n          permissions\n          email\n          profilePictureId\n          profilePictureDefaultId\n          active\n          isViewer\n          harvestUser\n          role {\n            id\n            name\n          }\n          personLabels(first: 1000) {\n            edges {\n              node {\n                id\n                label {\n                  id\n                  name\n                }\n              }\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  rateCard {\n    id\n    currency\n  }\n  invoices(first: 100000000) {\n    edges {\n      node {\n        status\n        id\n      }\n    }\n  }\n  client {\n    id\n  }\n  tasks(first: 100000) {\n    edges {\n      node {\n        id\n        name\n        companyTaskId\n        statusColumnV2 {\n          name\n          category\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '13b57e754d17acec882a67c8824abcf4';

module.exports = node;
